import { TAB_NAMES } from "src/apps/common/menu-navigation/menuNavigation";

export enum ACTIVE_VIEW {
  STANDARD = "standard",
  VENDOR = "vendor",
}

export enum ACTIVE_APP {
  STORE = "STORE",
  VENDOR = "vendor",
}

export const GENDERS = [
  {
    label: "Male",
    value: 1,
  },
  {
    label: "Female",
    value: 2,
  },
  {
    label: "Others",
    value: 3,
  },
];

export const IDENTITY_DOCUMENTS_OPTIONS = [
  {
    label: "Aadhar Card",
    value: 1,
  },
  {
    label: "Pan Card",
    value: 2,
  },
];

export const QUERY_SOURCES = [
  {
    label: "Email",
    value: 1,
  },
  {
    label: "Instagram",
    value: 2,
  },
  {
    label: "Facebook",
    value: 3,
  },
];

export const LEAD_TYPE = [
  {
    label: "New",
    value: 1,
  },
  {
    label: "Old",
    value: 2,
  },
  {
    label: "Repeat",
    value: 3,
  },
];

export const RATING_OPTIONS = [
  {
    label: "1",
    value: 1,
  },
  {
    label: "2",
    value: 2,
  },
  {
    label: "3",
    value: 3,
  },
  {
    label: "4",
    value: 4,
  },
  {
    label: "5",
    value: 5,
  },
];

export const PAYMENT_METHOD_OPTIONS = [
  {
    label: "Cash",
    value: 1,
  },
  {
    label: "Credit Card",
    value: 2,
  },
  {
    label: "UPI",
    value: 3,
  },
];

export const BREADCRUMBS = {
  [TAB_NAMES.CLIENT_MANAGEMENT]: [
    { label: "Clients", link: "/store/clients" },
    { label: "Add Client", link: "/clients/create" },
  ],
  [TAB_NAMES.APPOINTMENT]: [
    { label: "Appointments", link: "/store/appointments" },
    { label: "Add Appointment", link: "/appointments/create" },
  ],
  [TAB_NAMES.STAFF_MANAGEMENT]: [
    { label: "Staff", link: "/store/staff" },
    { label: "Add Staff", link: "/staff/create" },
  ],
  [TAB_NAMES.SERVICE_MANAGEMENT]: [
    { label: "Services", link: "/store/services" },
    { label: "Add Service", link: "/services/create" },
  ],
  [TAB_NAMES.PACKAGE_MANAGEMENT]: [
    { label: "Packages", link: "/store/packages" },
    { label: "Add Package", link: "/packages/create" },
  ],
  [TAB_NAMES.COURSE_MANAGEMENT]: [
    { label: "Courses", link: "/store/courses" },
    { label: "Add Course", link: "/courses/create" },
  ],
  [TAB_NAMES.MEMBERSHIP_MANAGEMENT]: [
    { label: "Memberships", link: "/store/memberships" },
    { label: "Add Membership", link: "/memberships/create" },
  ],
  [TAB_NAMES.COUPON_MANAGEMENT]: [
    { label: "Coupons", link: "/store/coupons" },
    { label: "Add Coupon", link: "/coupons/create" },
  ],
  [TAB_NAMES.ENQUIRY_MANAGEMENT]: [
    { label: "Enquiries", link: "/store/enquiries" },
    { label: "Add Enquiries", link: "/enquiries/create" },
  ],
  [TAB_NAMES.BILLING]: [
    { label: "Billing", link: "/store/billing" },
    { label: "Add Billing", link: "/billing/create" },
  ],
  [TAB_NAMES.WITHDRAW]: [
    { label: "Withdraws", link: "/store/withdraw" },
    { label: "Add Withdraw", link: "/withdraw/create" },
  ],
  [TAB_NAMES.EXPENSES]: [
    { label: "Expenses", link: "/store/expenses" },
    { label: "Add Expense", link: "/expenses/create" },
  ],
  [TAB_NAMES.VENDOR_MANAGEMENT]: [
    { label: "Vendors", link: "/store/vendor/vendors" },
    { label: "Add Vendor", link: "/vendor/vendors/create" },
  ],
  [TAB_NAMES.PRODUCTS]: [
    { label: "All Products", link: "/vendor/products" },
    { label: "Add New Products", link: "/vendor/products/create" },
  ],
};

export const BUSINESS_TYPE = [
  {
    label: "Sales",
    value: 1,
  },
];

export const UNIT = [
  {
    label: "KG",
    value: 1,
  },
  {
    label: "L",
    value: 2,
  },
  {
    label: "Unit",
    value: 3,
  },
];

export const CATEGORY = [
  {
    label: "Drinks",
    value: 1,
  },
  {
    label: "Food",
    value: 2,
  },
  {
    label: "Snacks",
    value: 3,
  },
];

export enum PR_STATUS {
  PENDING = 1,
  PROCESSING = 2,
  APPROVED = 3,
  REJECTED = 4,
  FULL_FILLED = 5,
  DECLINED = 6,
  COMPLETED = 7,
  IN_COMPLETED = 8,
}

export const PURCHASE_ORDER_STATUS = [
  {
    label: "Full Filled",
    value: PR_STATUS.FULL_FILLED,
  },
  {
    label: "Rejected",
    value: PR_STATUS.REJECTED,
  },
];

export const PROCUREMENT_REQUEST_STATUS = [
  {
    label: "Pending",
    value: PR_STATUS.PENDING,
  },
  {
    label: "Processing",
    value: PR_STATUS.PROCESSING,
  },
  {
    label: "Approved",
    value: PR_STATUS.APPROVED,
  },

  ...PURCHASE_ORDER_STATUS,
  {
    label: "Completed",
    value: PR_STATUS.COMPLETED,
  },
  {
    label: "In Completed",
    value: PR_STATUS.IN_COMPLETED,
  },
];

export enum INVENTORY_STATUS {
  PENDING = 1,
  APPROVED = 2,
  DECLINED = 3,
}

export const INVENTORY_STATUS_LABEL = [
  {
    label: "PENDING",
    value: INVENTORY_STATUS.PENDING,
  },
  {
    label: "APPROVED",
    value: INVENTORY_STATUS.APPROVED,
  },
  {
    label: "DECLINED",
    value: INVENTORY_STATUS.DECLINED,
  },
];

export enum APPOINTMENT_TYPES {
  SERVICE = 1,
  PACKAGE = 2,
  COURSE = 3,
}
export const LANGUAGES = [
  {
    label: "English",
    value: 1,
  },
  {
    label: "French",
    value: 2,
  },
];

export const FONT_FAMILIES = [
  {
    label: "Roboto",
    value: 1,
  },
  {
    label: "Arial",
    value: 2,
  },
];

export enum ROLES {
  SUPER_ADMIN = 1,
  ADMIN = 2,
}

export const ROLE_PERMISSION_FEATURES: { label: string; value: string }[] = [
  {
    label: "Dashboard",
    value: TAB_NAMES.DASHBOARD,
  },
  {
    label: "Appointment",
    value: TAB_NAMES.APPOINTMENT,
  },
  {
    label: "Client Management",
    value: TAB_NAMES.CLIENT_MANAGEMENT,
  },
  {
    label: "Staff Management",
    value: TAB_NAMES.STAFF_MANAGEMENT,
  },
  {
    label: "Service Management",
    value: TAB_NAMES.SERVICE_MANAGEMENT,
  },
  {
    label: "Package Management",
    value: TAB_NAMES.PACKAGE_MANAGEMENT,
  },
  {
    label: "Course Management",
    value: TAB_NAMES.COURSE_MANAGEMENT,
  },
  {
    label: "Membership Management",
    value: TAB_NAMES.MEMBERSHIP_MANAGEMENT,
  },
  {
    label: "Coupon Management",
    value: TAB_NAMES.COUPON_MANAGEMENT,
  },
  {
    label: "Enquiry Management",
    value: TAB_NAMES.ENQUIRY_MANAGEMENT,
  },
  {
    label: "Billing",
    value: TAB_NAMES.BILLING,
  },
  {
    label: "Withdraw",
    value: TAB_NAMES.WITHDRAW,
  },
  {
    label: "Expenses",
    value: TAB_NAMES.EXPENSES,
  },
  {
    label: "Roles",
    value: TAB_NAMES.ROLES,
  },
  {
    label: "Store",
    value: TAB_NAMES.STORE,
  },
  {
    label: "Users",
    value: TAB_NAMES.USERS,
  },
  {
    label: "Plans",
    value: TAB_NAMES.PLANS,
  },
  {
    label: "Data Export",
    value: TAB_NAMES.DATA_EXPORT,
  },
  {
    label: "Procurement Request",
    value: TAB_NAMES.PROCUREMENT_REQUEST,
  },
  {
    label: "Vendor Management",
    value: TAB_NAMES.VENDOR_MANAGEMENT,
  },
  {
    label: "Products",
    value: TAB_NAMES.PRODUCTS,
  },
  {
    label: "Purchase Order",
    value: TAB_NAMES.PURCHASE_ORDER,
  },
  {
    label: "Inventory Management",
    value: TAB_NAMES.INVENTORY_MANAGEMENT,
  },
  {
    label: "All Inventory",
    value: TAB_NAMES.ALL_INVENTORY,
  },
  {
    label: "Store Inventory",
    value: TAB_NAMES.STORE_INVENTORY,
  },
  {
    label: "Inventory Request",
    value: TAB_NAMES.INVENTORY_REQUEST,
  },
  {
    label: "Edit Store Settings",
    value: TAB_NAMES.EDIT_STORE_SETTINGS,
  },
];

export const PLANS_FEATURES: { label: string; value: string }[] = [
  { label: "Dashboard", value: TAB_NAMES.DASHBOARD },
  { label: "Appointment", value: TAB_NAMES.APPOINTMENT },
  { label: "Client Management", value: TAB_NAMES.CLIENT_MANAGEMENT },
  { label: "Staff Management", value: TAB_NAMES.STAFF_MANAGEMENT },
  { label: "Service Management", value: TAB_NAMES.SERVICE_MANAGEMENT },
  { label: "Package Management", value: TAB_NAMES.PACKAGE_MANAGEMENT },
  { label: "Course Management", value: TAB_NAMES.COURSE_MANAGEMENT },
  { label: "Membership Management", value: TAB_NAMES.MEMBERSHIP_MANAGEMENT },
  { label: "Coupon Management", value: TAB_NAMES.COUPON_MANAGEMENT },
  { label: "Enquiry Management", value: TAB_NAMES.ENQUIRY_MANAGEMENT },
  { label: "Billing", value: TAB_NAMES.BILLING },
  { label: "Withdraw", value: TAB_NAMES.WITHDRAW },
  { label: "Expenses", value: TAB_NAMES.EXPENSES },
  { label: "Roles", value: TAB_NAMES.ROLES },
  { label: "Store", value: TAB_NAMES.STORE },
  { label: "Users", value: TAB_NAMES.USERS },
  { label: "Plans", value: TAB_NAMES.PLANS },
  { label: "Vendor Management", value: TAB_NAMES.VENDOR_MANAGEMENT },
];

export enum ADDRESS {
  COUNTRY = "country",
  STATE = "state",
  CITY = "city",
}

const PENDING = "Pending";
const IN_PROGRESS = "In Progress";
const COMPLETED = "Completed";
const AVAILABLE = "Available";
const OUT_OF_STOCK = "Out of Stock";

export enum INVENTORY_REQUEST_STATUS {
  REQUESTED = 1,
  COMPLETED = 2,
  IN_COMPLETED = 3,
}

export const INVENTORY_REQUEST_STATUS_CELL = {
  [INVENTORY_REQUEST_STATUS.REQUESTED]: {
    label: "Requested",
    color: "#6226EF",
    bgColor: "#6226EF20",
  },
  [INVENTORY_REQUEST_STATUS.COMPLETED]: {
    label: COMPLETED,
    color: "#00b69b",
    bgColor: "#00B69B33",
  },
  [INVENTORY_REQUEST_STATUS.IN_COMPLETED]: {
    label: "In Completed",
    color: "#EF3826",
    bgColor: "#EF382620",
  },
};

export const PR_PO_STATUS_CELL = {
  [PR_STATUS.PENDING]: {
    label: PENDING,
    color: "#6226EF",
    bgColor: "#6226EF20",
  },
  [PR_STATUS.PROCESSING]: {
    label: "Processing",
    color: "#FFA756",
    bgColor: "#FFA75620",
  },
  [PR_STATUS.APPROVED]: {
    label: "Approved",
    color: "#00b69b",
    bgColor: "#00B69B33",
  },
  [PR_STATUS.REJECTED]: {
    label: "Rejected",
    color: "#EF3826",
    bgColor: "#EF382620",
  },
  [PR_STATUS.FULL_FILLED]: {
    label: "Full Filled",
    color: "#00b69b",
    bgColor: "#00B69B33",
  },
  [PR_STATUS.DECLINED]: {
    label: "Declined",
    color: "#EF3826",
    bgColor: "#EF382620",
  },
  [PR_STATUS.COMPLETED]: {
    label: COMPLETED,
    color: "#00b69b",
    bgColor: "#00B69B33",
  },
  [PR_STATUS.IN_COMPLETED]: {
    label: "In Completed",
    color: "#EF3826",
    bgColor: "#EF382620",
  },
};

export enum LEAD_STATUS {
  PENDING = 1,
  IN_PROGRESS = 2,
  COMPLETED = 3,
}

export const LEAD_STATUS_OPTIONS = [
  {
    label: PENDING,
    value: LEAD_STATUS.PENDING,
  },
  {
    label: IN_PROGRESS,
    value: LEAD_STATUS.IN_PROGRESS,
  },
  {
    label: COMPLETED,
    value: LEAD_STATUS.COMPLETED,
  },
];

export const LEAD_STATUS_CELL = {
  [LEAD_STATUS.PENDING]: {
    label: PENDING,
    color: "#6226EF",
    bgColor: "#6226EF20",
  },
  [LEAD_STATUS.IN_PROGRESS]: {
    label: IN_PROGRESS,
    color: "#FFA756",
    bgColor: "#FFA75620",
  },
  [LEAD_STATUS.COMPLETED]: {
    label: COMPLETED,
    color: "#00b69b",
    bgColor: "#00B69B33",
  },
};

export enum PRODUCT_STATUS {
  AVAILABLE = 1,
  OUT_OF_STOCK = 2,
}

export const PRODUCT_STATUS_OPTIONS = [
  {
    label: AVAILABLE,
    value: PRODUCT_STATUS.AVAILABLE,
  },
  {
    label: OUT_OF_STOCK,
    value: PRODUCT_STATUS.OUT_OF_STOCK,
  },
];

export const PRODUCT_STATUS_CELL = {
  [PRODUCT_STATUS.AVAILABLE]: {
    label: AVAILABLE,
    color: "#00b69b",
    bgColor: "#00B69B33",
  },
  [PRODUCT_STATUS.OUT_OF_STOCK]: {
    label: OUT_OF_STOCK,
    color: "#EF3826",
    bgColor: "#EF382620",
  },
};
